import { useContext } from "react";
import { RecipientAdapterContext } from "./adapter-context";
import type { RecipientTokenAdapter } from "./types";

/** Read the active recipient token adapter from context (mock in Phase D). */
export function useRecipientAdapter(): RecipientTokenAdapter {
  return useContext(RecipientAdapterContext);
}
